/* Set the webpack public path correctly, because out build directory is
   different from our url path - so webpack can't set the lazy loaded
   paths correctly. Open to alternatives.  */
__webpack_public_path__ = `${window.location.origin}/resource-detail/assets/`; // eslint-disable-line no-undef
import '../../js/job-ads-web-component';
import './context';
import './buy-resource';
import './download-resource';
import './price';
import './save-for-later';
import './bundle-price';
import './reviews';
import '../shared/search';
import '../shared/mz-helper';
import '../shared/ad';
import '../shared/user-name'
import '../shared/avatar';
import '../shared/profile-cta';
import './write-review';
import './review-item';
import './review-author-buttons';
import './reply-author-buttons';
import './licence-upgrade';
import './author-description';
import './cta-sticky';


/* If requestIdleCallback is available in this browser, then use it to wait
   for main thread idle time (after the page has rendered) to lazy load the
   non-critical or heavier components on the page. */
const lazyLoadComponents = window.requestIdleCallback || ((cb) => cb());

lazyLoadComponents(() => {
  import(/* webpackChunkName: "preview-files" */ './preview-files');
  import(/* webpackChunkName: "country-selector" */ '../shared/country-selector');
});
